var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconFolder = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-672 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M687.571,181.286a1,1,0,0,1-1,1H685v1.571a1,1,0,1,1-2,0v-1.571h-1.571a1,1,0,0,1,0-2H683v-1.572a1,1,0,1,1,2,0v1.572h1.571A1,1,0,0,1,687.571,181.286ZM694,176.143v10.286a2.288,2.288,0,0,1-2.286,2.285H676.286A2.288,2.288,0,0,1,674,186.429V173.571a2.288,2.288,0,0,1,2.286-2.285h3.324a2.273,2.273,0,0,1,1.616.668l1.9,1.9h8.586A2.288,2.288,0,0,1,694,176.143Zm-2,0a.286.286,0,0,0-.286-.286h-9a1,1,0,0,1-.707-.293l-2.2-2.195a.284.284,0,0,0-.2-.083h-3.324a.286.286,0,0,0-.286.285v12.858a.286.286,0,0,0,.286.285h15.428a.286.286,0,0,0,.286-.285Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-folder.32f78001.svg";
export { ForwardRef as ReactComponent };